import { createSlice } from "@reduxjs/toolkit";

const ticketSlice = createSlice({
  name: "ticket",
  initialState: {
    ticketData: null,
    isGetSupportTicketLoading: false,
    isUpdateSupportTicketLoading: false,
  },
  reducers: {
    // get
    getSupportTicketLoading: (state) => {
      state.isGetSupportTicketLoading = true;
    },
    getSupportTicketSuccess: (state, action) => {
      state.ticketData = action.payload;
      state.isGetSupportTicketLoading = false;
    },
    getSupportTicketFailure: (state) => {
      state.isGetSupportTicketLoading = false;
    },
    // update
    updateSupportTicketLoading: (state) => {
      state.isUpdateSupportTicketLoading = true;
    },
    updateSupportTicketSuccess: (state, action) => {
      state.ticketData = action.payload;
      state.isUpdateSupportTicketLoading = false;
    },
    updateSupportTicketFailure: (state) => {
      state.isUpdateSupportTicketLoading = false;
    },
  },
});

export const {
  getSupportTicketLoading,
  getSupportTicketSuccess,
  getSupportTicketFailure,
  updateSupportTicketLoading,
  updateSupportTicketSuccess,
  updateSupportTicketFailure,
} = ticketSlice.actions;

export default ticketSlice.reducer;
